import { createFileRoute } from "@tanstack/react-router";
import { SilverPage, silverRatesQO } from "@/components/SilverPage";
import { buildAliasHead } from "@/lib/alias-routes";

const TITLE = "Today's Live Chandi Ka Rate in Chennai — 1 Tola & 10 Gram Silver Price";
const DESC = "Live silver / chandi rate in Chennai today — per tola, per 10 gram, per gram & per kg. Hourly auto-update from international XAG spot + USD/INR FX.";

export const Route = createFileRoute("/silver-rate-chennai")({
  head: () => buildAliasHead({ title: TITLE, description: DESC, path: "/silver-rate-chennai" }),
  loader: ({ context }) => context.queryClient.ensureQueryData(silverRatesQO),
  component: () => (
    <SilverPage
      country="india"
      cityName="Chennai"
      title="Today's Live Chandi (Silver) Rate in Chennai"
      intro="Live silver rate in Chennai — recalculated every 10 minutes from international XAG spot price and today's USD/INR rate. Per tola, per 10 gram, per gram and per kilogram."
    />
  ),
});
